import type { PImage } from '../../engine/aliases'
import { l } from '../../lib/imports'
import { common } from '../../main/common-sidecar'
import { voyageCameraStarmap } from './voyageCameraStarmap-sidecar'
import { voyageCamera_mover } from './voyageCamera_mover-sidecar'
import { voyageCamera_shaker } from './voyageCamera_shaker-sidecar'
import { voyageCamera_zoomer } from './voyageCamera_zoomer-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'

export interface IBounds {
  x: number
  y: number
  w: number
  h: number
}

export interface IVoyageCamera {
  zoom: number
  cameraX: number
  cameraY: number
  bounds: IBounds
}

let _obj: IVoyageCamera | null = null
export function get() {
  if (!_obj) {
    _obj = create()
    setCameraXY(-200, -200)
  }
  return _obj
}

function create() {
  let bounds = 128 * 20
  // let bounds = 0
  let obj: IVoyageCamera = {
    zoom: 1,
    cameraX: 0,
    cameraY: 0,
    bounds: {
      x: -bounds,
      y: -bounds,
      w: 100 * 32 + bounds * 2,
      h: 100 * 32 + bounds * 2,
    },
  }
  return obj
}

export function getUiMousePosition() {
  let s = common.getPhaserScene()
  let mx = s.input.mousePointer.x
  let my = s.input.mousePointer.y
  return { mx, my }
}

export function getAdjustedMousePosition() {
  let s = common.getPhaserScene()
  let mx = s.input.mousePointer.x
  let my = s.input.mousePointer.y
  return getUiPositionToGamePosition(mx, my)
}
export function getUiPositionToGamePosition(uix: number, uiy: number) {
  let obj = get()
  let zoom = getZoom()

  let gx = (uix + obj.cameraX) / zoom
  let gy = (uiy + obj.cameraY) / zoom

  return { x: gx, y: gy }
}
export function getGamePositionToUiPosition(gx: number, gy: number) {
  let obj = get()
  let zoom = getZoom()

  let mx = gx * zoom - obj.cameraX
  let my = gy * zoom - obj.cameraY

  return { x: mx, y: my }
}

export function getGameBounds() {
  let scale = common.getPhaserScene().sys.game.scale
  return { width: scale.width, height: scale.height }
}

export function centerOn(x: number, y: number) {
  let obj = get()
  let gb = getGameBounds()
  setCameraXY(x * obj.zoom - gb.width / 2, y * obj.zoom - gb.height / 2)
}

export function getCenter() {
  let obj = get()
  let gb = getGameBounds()

  let x = obj.cameraX + gb.width / 2 / obj.zoom
  let y = obj.cameraY + gb.height / 2 / obj.zoom

  return { x, y }
}

export const getCenterXY = () => {
  let obj = get()
  let gb = getGameBounds()
  return {
    x: (obj.cameraX + gb.width / 2) / obj.zoom, // / data.zoom,
    y: (obj.cameraY + gb.height / 2) / obj.zoom, // / data.zoom,
  }
}

export function update() {
  let obj = get()
  voyageCamera_shaker.update()

  voyageCamera_mover.update(obj)

  voyageCamera_zoomer.update()
  _updateLayers()

  // let ap = common.getPhaserScene().game.input.activePointer
}

function _updateLayers() {
  let obj = get()
  let layers = voyageLayers.getLayersOnMainCamera()

  let gs = voyageCamera_shaker.get()
  let cx = obj.cameraX + gs.shakeX
  let cy = obj.cameraY + gs.shakeY
  // console.log('klayers?', layers.length)
  l.forEach(layers, (c) => {
    c.x = -cx
    c.y = -cy
  })
}

export function setCameraXY(x: number, y: number) {
  let obj = get()

  let bounded = constrainToBounds(x, y, obj.bounds)
  obj.cameraX = bounded.x
  obj.cameraY = bounded.y
  _updateLayers()
}

export function isOffScreen(sprite: PImage, tolerance = 150) {
  let gb = getGameBounds()
  let obj = get()

  // TODO: width / 2?
  if (
    sprite.x + sprite.width * sprite.scale + tolerance < 0 + obj.cameraX ||
    sprite.x - sprite.width * sprite.scale - tolerance > gb.width + obj.cameraX
  ) {
    return true
  }

  if (
    sprite.y + sprite.height * sprite.scale + tolerance < 0 + obj.cameraY ||
    sprite.y - sprite.height * sprite.scale - tolerance >
      gb.height + obj.cameraY
  ) {
    return true
  }

  return false
}

export function constrainToBounds(x: number, y: number, bounds: IBounds) {
  let ix = x
  let iy = y
  let gb = getGameBounds()

  let zoom = get().zoom
  let bx = bounds.x * zoom
  let by = bounds.y * zoom

  if (ix < bx) {
    ix = bx
  }
  if (iy < by) {
    iy = by
  }

  let bw = bounds.w * zoom
  let br = bx + bw - gb.width
  if (gb.width > bw) {
    br += (gb.width - bw) / 2
  }
  if (ix > br) {
    ix = br
  }

  let bh = bounds.h * zoom
  let bb = by + bh - gb.height
  if (gb.height > bh) {
    bb += (gb.height - bh) / 2
  }
  if (iy > bb) {
    iy = bb
  }

  x = ix
  y = iy
  return { x, y }
}

export function setZoom(newZoom: number) {
  let obj = get()

  if (newZoom === obj.zoom) {
    return
  }
  let oldZoom = obj.zoom

  let isZoomIn = newZoom > oldZoom
  let zoomDelta = newZoom - oldZoom

  console.log('camera', 'set zoom', obj.zoom, newZoom, zoomDelta)

  let gb = getGameBounds()

  let center = getCenterXY()
  console.log('camera', 'c1', center.x, center.y)

  // let cx = obj.cameraX + gb.width / 2 / obj.zoom
  // let cy = obj.cameraY + gb.height / 2 / obj.zoom

  let mou = getAdjustedMousePosition()

  let sc = common.getPhaserScene()

  obj.zoom = newZoom
  l.forEach(voyageLayers.getLayersOnMainCamera(), (c) => {
    c.scale = newZoom
  })

  centerOn(center.x, center.y)
  center = getCenterXY()
  console.log('camera', 'c2', center.x, center.y)

  // centerOn(cx, cy)

  // if (zoomDelta > 0) {
  //   let oldWidth = (1 / oldZoom) * gb.width
  //   let oldHeight = (1 / oldZoom) * gb.height

  //   console.log('camera', 'zoom in', oldWidth, oldHeight)

  //   setCameraXY(obj.cameraX + oldWidth / 4, obj.cameraY + oldHeight / 4)

  //   // centerOn(mou.x, mou.y)
  //   // setCameraXY(obj.cameraX + gb.width / 2, obj.cameraY + gb.height / 2)
  // }

  // if (zoomDelta < 0) {
  //   let oldWidth = (1 / oldZoom) * gb.width
  //   let oldHeight = (1 / oldZoom) * gb.height
  //   setCameraXY(obj.cameraX - oldWidth / 4, obj.cameraY - oldHeight / 4)
  // }

  // if (zoomDelta < 0) {
  //   setCameraXY(obj.cameraX - gb.width / 2, obj.cameraY - gb.height / 2)
  // }

  // if (isZoomIn) {
  //   //centerOn(mou.x, mou.y)
  // }

  //sc.cameras.main.setZoom(zoom)
}

export function getZoom() {
  return get().zoom
}
